module.exports = __webpack_public_path__ + "static/media/app-logo.151f3768.png";